import { Delete, Edit, MoreHoriz, Password, Person, PersonOff } from '@mui/icons-material'
import { Tag } from '@workwave-tidal/core/components'

import { preview } from '@/components/form/preview'

import { useOnChangePassword } from './hooks/useOnChangePassword'
import { useOnCloseUserDetails } from './hooks/useOnCloseUserDetails'
import { useOnDeleteUser } from './hooks/useOnDeleteUser'
import { useOnEditUser } from './hooks/useOnEditUser'
import { useOnToggleUser } from './hooks/useOnToggleUser'
import { useTexts } from './hooks/useTexts'

type Props = {
  user: uui.domain.client.rm.RouteManagerUser
  selectedUsers: uui.domain.client.rm.RouteManagerUser[]
}

export function ViewHeader(props: Props) {
  const { user, selectedUsers } = props
  const texts = useTexts()

  const { enabled, id } = selectedUsers[0]
  const toggleUserTitle = enabled ? texts.menu.disabled : texts.menu.enabled
  const role = user.type

  const onChangePassword = useOnChangePassword()
  const onCloseUserDetails = useOnCloseUserDetails()
  const onEditUser = useOnEditUser()
  const onDeleteUser = useOnDeleteUser()
  const onToggleUser = useOnToggleUser()

  return (
    <>
      <preview.Header
        title={
          <>
            {user.name} {user.surname}
            {!enabled && <Tag label={texts.disabled} sx={{ marginLeft: 1, fontSize: '13px' }} />}
          </>
        }
        onClose={onCloseUserDetails}
        subtitle={texts.roles[role]}
      >
        <preview.ActionBar
          limit={3}
          menuMode="textOnly"
          menuIcon={<MoreHoriz />}
          menuTooltip={texts.tooltips.more}
          componentsProps={{
            // @ts-expect-error
            menuButton: { 'data-testid': 'user-more', 'data-trackid': 'user-more' },
          }}
        >
          <preview.ActionBarItem
            icon={<Edit />}
            onClick={onEditUser}
            label={texts.tooltips.edit}
            tooltip={texts.tooltips.edit}
            disableWhenReadOnly
            testId="user-edit"
            data-trackid="user-edit"
          />
          <preview.ActionBarItem
            icon={<Password />}
            onClick={onChangePassword}
            label={texts.menu.changePassword}
            tooltip={texts.menu.changePassword}
            testId="user-change-password"
            data-trackid="user-change-password"
            disableWhenReadOnly
          />
          <preview.ActionBarItem
            icon={<Delete />}
            onClick={onDeleteUser}
            label={texts.tooltips.delete}
            tooltip={texts.tooltips.delete}
            testId="user-delete"
            data-trackid="user-delete"
            disableWhenReadOnly
          />
          <preview.ActionBarItem
            icon={enabled ? <PersonOff /> : <Person />}
            onClick={() => onToggleUser(enabled, id)}
            label={toggleUserTitle}
            tooltip={toggleUserTitle}
            testId="user-toggleUser"
            data-trackid="user-toggleUser"
            disableWhenReadOnly
          />
        </preview.ActionBar>
      </preview.Header>
    </>
  )
}
